import React from 'react';
import AffiliateCarCard from './AffiliateCarCard';
import InternalCarCard from './InternalCarCard';

const CarTypeMappingItem = ({
  affiliationCarType, // AffiliationCarType object từ API
  selectedCarTypeId,
  carTypeOptions,
  onChange,
  getSelectedCarType,
  checkCapacityWarning,
}) => {
  const selectedCarType = getSelectedCarType(selectedCarTypeId);
  const hasWarning = checkCapacityWarning(affiliationCarType, selectedCarType);

  // Convert AffiliationCarType schema sang format cho AffiliateCarCard
  const affiliateCarForCard = {
    _id: affiliationCarType._id,
    key: affiliationCarType._id,
    label: affiliationCarType.name,
    icon: affiliationCarType.iconSlider, // Sử dụng iconSlider từ AffiliationCarType
    passengers: affiliationCarType.maxPassengers || 0,
    luggage: affiliationCarType.maxLuggages || 0,
  };

  return (
    <div className="car-type-mapping-item">
      <AffiliateCarCard car={affiliateCarForCard} />
      <div className="mapping-arrow">→</div>
      <InternalCarCard
        selectedCarType={selectedCarType}
        options={carTypeOptions}
        value={selectedCarTypeId}
        onChange={(e) => onChange(affiliationCarType._id, e.target.value)}
        hasWarning={hasWarning}
      />
    </div>
  );
};

export default CarTypeMappingItem;